import { useNavigate, useLocation } from "react-router-dom";
import { Home, ShoppingBag, Barcode, Search, User } from "lucide-react";

const navItems = [
  { icon: Home, label: "Home", path: "/" },
  { icon: ShoppingBag, label: "Shop", path: "/shop" },
  { icon: Barcode, label: "Scan", path: "/scanner", fab: true },
  { icon: Search, label: "Lookup", path: "/lookup" },
  { icon: User, label: "Account", path: "/signin" },
];

const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 bg-card/80 backdrop-blur-xl border-t border-border safe-area-bottom">
      <div className="max-w-lg mx-auto flex items-end justify-around px-2 pt-1 pb-2">
        {navItems.map((item) =>
          item.fab ? (
            <button
              key={item.label}
              onClick={() => navigate(item.path)}
              aria-label={item.label}
              className="relative -mt-6 w-14 h-14 rounded-full bg-primary text-primary-foreground flex items-center justify-center shadow-lg shadow-primary/30 hover:scale-105 active:scale-95 transition-transform"
            >
              <item.icon className="w-6 h-6" />
            </button>
          ) : (
            <button
              key={item.label}
              onClick={() => navigate(item.path)}
              className={`flex flex-col items-center gap-0.5 px-3 py-1.5 rounded-xl transition-colors ${
                location.pathname === item.path
                  ? "text-primary"
                  : "text-muted-foreground hover:text-foreground"
              }`}
            >
              <item.icon className="w-5 h-5" />
              <span className="text-[10px] font-mono tracking-wide">{item.label}</span>
            </button>
          )
        )}
      </div>
    </nav>
  );
};

export default BottomNav;
